function c(e, o) {
  const t = new Error(o);
  return t.type = e, t;
}
function d(e) {
  if (e.first && e.last)
    throw c(
      "validation",
      "System cannot have both first and last constraints"
    );
}
function l(e, o) {
  const t = e.group ?? "simulation";
  if (e.before)
    for (const n of e.before) {
      if (!o.includes(n)) continue;
      const r = n.group ?? "simulation";
      if (r !== t)
        throw c(
          "group-mismatch",
          `System with before constraint references system in different group (${t} vs ${r})`
        );
    }
  if (e.after)
    for (const n of e.after) {
      if (!o.includes(n)) continue;
      const r = n.group ?? "simulation";
      if (r !== t)
        throw c(
          "group-mismatch",
          `System with after constraint references system in different group (${t} vs ${r})`
        );
    }
}
function p(e) {
  const o = /* @__PURE__ */ new Map();
  for (const t of e) {
    if (o.has(t) || o.set(t, /* @__PURE__ */ new Set()), t.before)
      for (const n of t.before)
        e.includes(n) && (o.has(n) || o.set(n, /* @__PURE__ */ new Set()), o.get(t).add(n));
    if (t.after)
      for (const n of t.after)
        e.includes(n) && (o.has(n) || o.set(n, /* @__PURE__ */ new Set()), o.get(n).add(t));
  }
  return o;
}
function h(e) {
  const o = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Set();
  function n(r) {
    if (t.has(r)) return !0;
    if (o.has(r)) return !1;
    o.add(r), t.add(r);
    const f = e.get(r);
    return f?.size && [...f].some(n) ? !0 : (t.delete(r), !1);
  }
  for (const r of e.keys())
    if (n(r))
      throw c(
        "circular-dependency",
        "Circular dependency detected in system constraints"
      );
}
function a(e) {
  if (e.length === 0) return [];
  const o = p(e);
  h(o);
  const t = /* @__PURE__ */ new Map();
  for (const f of e)
    t.set(f, 0);
  for (const f of o.values())
    for (const i of f)
      t.set(i, (t.get(i) || 0) + 1);
  const n = [], r = [];
  for (const f of e)
    t.get(f) === 0 && n.push(f);
  for (; n.length > 0; ) {
    const f = n.shift();
    r.push(f);
    const i = o.get(f) || /* @__PURE__ */ new Set();
    for (const s of i) {
      const u = (t.get(s) || 0) - 1;
      t.set(s, u), u === 0 && n.push(s);
    }
  }
  return r;
}
function g(e, o, t) {
  const n = t || e;
  e.forEach((f) => {
    d(f), l(f, n);
  });
  const r = e.reduce(
    (f, i) => {
      const s = i.first ? "first" : i.last ? "last" : "normal";
      return f[s].push(i), f;
    },
    { first: [], normal: [], last: [] }
  );
  return [
    ...a(r.first),
    ...a(r.normal),
    ...a(r.last)
  ];
}
export {
  g as sortSystemsByConstraints,
  l as validateGroupConstraints,
  d as validateSystemConstraints
};
//# sourceMappingURL=ordering.js.map
